import(/* webpackMode: "eager" */ "/workspace/app/[locale]/not-found.tsx");
